import React, { useCallback, useMemo } from 'react';
import { TextField, FormControlLabel } from '@mui/material';

import { SectionBase } from './SectionBase';
import { RadioGroup } from './RadioGroup';
import styled from 'styled-components';

export const SectionYesNoDollars = ({
  title,
  subTitle,
  helpText,
  options: options0,
  questionId,
  guidanceText,
  value,
  onChange,
  error,
  programName,
  extraClass = '',
  total,
}) => {
  const options = useMemo(() => options0?.map(response => response), [
    options0,
  ]);

  const handleChange = useCallback(
    event => {
      onChange(questionId, {
        ...value,
        value: event.target.value,
      });
    },
    [onChange, questionId, value],
  );
  const handleClick = useCallback(
    event => {
      if (event.target.value === value) {
        onChange(questionId, {
          ...value,
          value: event.target.value,
        });
      }
    },
    [questionId, onChange, value],
  );
  const handleChangeValue = useCallback(
    event => {
      onChange(questionId, {
        ...value,
        amount: event.target.value,
      });
    },
    [onChange, questionId, value],
  );
  const handleChangePercent = useCallback(
    event => {
      const calc = Math.round(
        (parseFloat(event.target.value || '0') * total) / 100,
      );

      onChange(questionId, {
        ...value,
        amount: calc,
      });
    },
    [value, total, onChange, questionId],
  );

  return (
    <SectionBase
      {...{
        title,
        subTitle,
        helpText,
        error,
        extraClass,
        guidanceText,
        questionId,
      }}
    >
      {programName && (
        <Box>
          <p>
            <label className="title-5">{programName}</label>
          </p>
        </Box>
      )}
      <RadioGroup
        {...{ subTitle, options, value }}
        onChange={handleChange}
        onClick={handleClick}
      />
      {value?.value === 'No' && (
        <div>
          <FormControlLabel
            label="Amount ($)"
            control={
              <TextField value={value?.amount} onChange={handleChangeValue} />
            }
          />
          <br />
          <TextField
            disabled={!total}
            value={
              value?.amount && total
                ? Math.round((value?.amount * 100) / total)
                : ''
            }
            onChange={handleChangePercent}
          />
        </div>
      )}
    </SectionBase>
  );
};

const Box = styled.div`
  width: 100%;
  height: auto;
  margin-top: 20px;
  min-height: 40px;
  padding-left: 15px;
  padding-right: 15px;
  border: solid 1px #cbd6e2;
  border-radius: 4px;
  background-color: #ffffff;
`;
